import React from 'react';
import './SidebarFooter.css';
import FeedbackModal from '../modal/FeedbackModal';
import Modal from '../modal/Modal';

const SidebarFooter = () => {

    const [feedbackModalOpen, setFeedbackModalOpen] = React.useState(false);

    return (
        <>
        <div className="sidebar-footer">
            <div className="sidebar-footer-links">
                <a href="/about">About</a>
                <span role="button" onClick={() => setFeedbackModalOpen(true)} className="hover-underline">Feedback</span>
                <a href="/terms">T&C</a>
            </div>
            <div className="sidebar-footer-copy">
                &copy; 2025 Takomori (Beta)
            </div>
        </div>
        
            <Modal
                isOpen={feedbackModalOpen}
                onClose={() => setFeedbackModalOpen(false)}
                content={<FeedbackModal onClose={() => setFeedbackModalOpen(false)} />}
            />
        </>
    );
};

export default SidebarFooter;
